import PropTypes from 'prop-types'

const RecordFill = ({
  width = '24',
  height = '24',
  className = '',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="currentColor"
    className={`bi bi-record-fill ${className}`}
    {...{ ...props }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" d="M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10z" />
  </svg>
)

RecordFill.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
}

RecordFill.defaultProps = {
  width: '24',
  height: '24',
  className: '',
}

export default RecordFill
